import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import TableChartIcon from '@mui/icons-material/TableChart'
import BaseNode from './BaseNode'
import { VisualizationNodeData } from '../types'

const VisualizationNode: FC<NodeProps> = ({ id, data, selected }) => {
  const nodeData = data as VisualizationNodeData
  const subtitle = 'Auto-detect'

  return (
    <BaseNode
      nodeType="visualization"
      icon={<TableChartIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
      ]}
    />
  )
}

export default memo(VisualizationNode)
